import CircularProgress from '../CircularProgress/CircularProgress.jsx';
import Icon from '../Icon/Icon.jsx';

export interface ColorByProcessingStatusInterface {
  text: string;
  background: 'tertiary' | 'error' | 'success';
}

export const colorByProcessingStatus: {
  [type: string]: ColorByProcessingStatusInterface;
} = {
  default: { text: 'tertiary.dark', background: 'tertiary' },
  error: { text: 'error.dark', background: 'error' },
  success: { text: 'success.dark', background: 'success' },
};

export const processingStatusElements = {
  default: () => <CircularProgress size={16} color="primary" />,
  error: () => <Icon color="error" component="WarningAltFilled" />,
  success: () => <Icon color="success" component="CheckmarkFilled" />,
};
